import type { ReactNode, SyntheticEvent } from 'react';
import { useTracking } from 'react-tracking';

import { LoadingSpinner } from '@simplywallst/ui-core';
import PlusSolid from '@simplywallst/ui-core/icons/PlusSolid';
import TickSolid from '@simplywallst/ui-core/icons/TickSolid';

import AddButton from '../AddButton';
import { Title, Details, Wrapper, Add } from './styled';

export interface Props {
  name: string;
  title: string;
  details?: string;
  checked?: boolean;
  disabled?: boolean;
  isUpdating?: boolean;
  trackingProps?: Record<string, string>;
  handleClick?: (e: SyntheticEvent<HTMLLIElement, MouseEvent>) => void;
  children?: ReactNode;
}

const ListItem = ({
  name,
  title,
  details = '',
  checked = false,
  disabled = false,
  isUpdating = false,
  children = null,
  handleClick,
}: Props) => {
  const { trackEvent } = useTracking({
    type: 'track',
    modifier: name || undefined,
  });

  return (
    <Wrapper
      onClick={(e) => {
        if (!disabled) {
          handleClick?.(e);
          trackEvent({
            action: 'toggle',
            checked: !checked,
          });
        }
      }}
      data-cy-id={`checkbox-list-item-${name}`}
      disabled={disabled}
    >
      <Title>{title}</Title>
      <Details>{details}</Details>
      <Add>
        {children ? (
          children
        ) : (
          <AddButton
            data-cy-id={`list-item-button-${name}`}
            styleType="louder"
            styleTypeOverride={checked ? 'added' : 'add'}
            alignIcon="left"
            disabled={disabled}
          >
            {isUpdating ? (
              <LoadingSpinner
                light={true}
                width={16}
                top="16px"
                left="18px"
                zIndex={1}
              />
            ) : checked ? (
              <TickSolid />
            ) : (
              <PlusSolid />
            )}
            {checked ? 'Added' : 'Add'}
          </AddButton>
        )}
      </Add>
    </Wrapper>
  );
};

export default ListItem;
